var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotUpdatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00065 26.5V24.1667L10.1673 23H4.33398V5.5H16.0007V7.83333H6.66732V20.6667H25.334V17.1667H27.6673V23H21.834L23.0007 24.1667V26.5H9.00065ZM19.5007 19.5L13.6673 13.6667L15.3007 12.0333L18.334 15.0375V5.5H20.6673V15.0375L23.7007 12.0333L25.334 13.6667L19.5007 19.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotUpdatedIcon);
export default __webpack_public_path__ + "static/media/not-updated-icon.8fd243b23543263a02b23509d6892b6e.svg";
export { ForwardRef as ReactComponent };